import { CORE_DEFAULT_VALUES } from '../../core/config/defaultValues/defaultValues';
import { ERP_DEFAULT_VALUES } from '../../erp/config/defaultValues/defaultValues';

export const DEFAULT_VALUES = {
  ...CORE_DEFAULT_VALUES,
  ...ERP_DEFAULT_VALUES,
  defaultCountryState: 'LT',
  currencyState: '€',
  isInternationalCountryName: false,
  isDateSelectPreferred: true,
  defaultCardStyle: {
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    boxShadow:
      'rgba(145, 158, 171, 0.2) 0 0 2px 0, rgba(145, 158, 171, 0.12) 0 12px 24px -4px',
  },
  defaultCountry: 'LT',
};
